function SvgComponent(props: any) {

    return (
        <svg
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <rect
            x={0.5}
            y={0.5}
            width={39}
            height={39}
            rx={3.5}
            fill="#282828"
            stroke="#282828"
        />
        <path
            d="M21.82 30h-3.64a1 1 0 01-.977-.786l-.407-1.884a8 8 0 01-1.535-.887l-1.837.585a1 1 0 01-1.17-.453l-1.824-3.151a1.006 1.006 0 01.193-1.239l1.425-1.3a8.1 8.1 0 010-1.772l-1.425-1.297a1.006 1.006 0 01-.193-1.24l1.82-3.153a1 1 0 011.17-.453l1.837.585c.244-.18.498-.348.76-.5.253-.142.513-.271.779-.386l.408-1.882A1 1 0 0118.18 10h3.64a1 1 0 01.976.787l.412 1.883a7.995 7.995 0 011.534.887l1.838-.585a1 1 0 011.169.453l1.82 3.153c.232.407.152.922-.193 1.239l-1.425 1.3a8.1 8.1 0 010 1.772l1.425 1.3c.345.318.425.832.193 1.239l-1.82 3.153a1 1 0 01-1.17.453l-1.837-.585a7.985 7.985 0 01-1.534.886l-.412 1.879a1 1 0 01-.976.786zm-6.2-5.771l.82.6c.185.136.377.261.577.375.188.109.38.207.579.296l.933.409.457 2.091h2.03l.457-2.092.933-.409c.407-.18.794-.403 1.153-.666l.82-.6 2.042.65 1.015-1.758-1.583-1.443.112-1.012c.05-.443.05-.89 0-1.332l-.112-1.012 1.584-1.446-1.016-1.759-2.041.65-.821-.6a6.227 6.227 0 00-1.153-.671l-.933-.409L21.016 12h-2.03l-.46 2.092-.93.408a6.012 6.012 0 00-1.153.666l-.821.6-2.04-.65-1.017 1.764 1.583 1.441-.112 1.013c-.05.443-.05.89 0 1.332l.112 1.012-1.583 1.443 1.015 1.758 2.04-.65zM19.996 24a4 4 0 110-8 4 4 0 010 8zm0-6a2 2 0 102 2.09v.4V20a2 2 0 00-2-2z"
            fill={props.isHover ? "#5627FF" : "#fff"}
        />
        </svg>
    )
}
  
  export default SvgComponent